import { c as _c } from "react/compiler-runtime";
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import EmailSelect from 'modules/automation-rules/triggers/components/edit-triggers/components/trigger-email-item/components/email-select';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggerEmailLinkEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import { FormSelect } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getClickedLinkCaption, getClickedLinkCustomCaption } from './get-clicked-link-name';
interface TriggerEmailLinkItemProps extends EditTriggerItemInterface<TriggerEmailLinkEditInterface> {}
const TriggerEmailLinkItem = t0 => {
  const $ = _c(18);
  const {
    trigger,
    triggers,
    idx,
    errors,
    setRules,
    onDelete,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== errors || $[4] !== idx || $[5] !== isStatic || $[6] !== setRules || $[7] !== t || $[8] !== trigger.id || $[9] !== trigger.link || $[10] !== trigger.mailing.currentEmail?.subject || $[11] !== trigger.mailing.id || $[12] !== triggers) {
    t2 = t3 => {
      const {
        data,
        onOpen,
        onClear
      } = t3;
      return <><EmailSelect isStatic={isStatic} emailData={data.emailData} onChange={data_0 => {
          setRules(prev => ({
            ...prev,
            triggers: triggers.map((el, i) => {
              if (idx === i) {
                return {
                  ...el,
                  mailing: {
                    id: data_0
                  },
                  link: {
                    id: undefined
                  }
                };
              } else {
                return el;
              }
            })
          }));
          onClear(AutomationRuleTriggersDataEnum.email_link);
        }} errors={errors} triggerId={trigger.id} mailingId={trigger.mailing.id} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.email)} subject={trigger.mailing.currentEmail?.subject} />{trigger.mailing?.id && <FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.email_link)} label={t("dashboard.automation_rule.email_link")} placeholder={t("dashboard.automation_rule.choose_email_link")} value={trigger.link?.id} staticData={trigger.link && getDataFromObj({
          id: trigger.link.id,
          name: getClickedLinkCaption(t, trigger.link.type, trigger.link.displayLinkName),
          customCaption: getClickedLinkCustomCaption(t, trigger.link.type, trigger.link.displayLinkName)
        })} data={data.emailLinksData} onChange={data_1 => setRules(prev_0 => ({
          ...prev_0,
          triggers: triggers.map((el_0, i_0) => {
            if (idx === i_0) {
              return {
                ...el_0,
                link: {
                  id: data_1
                }
              };
            } else {
              return el_0;
            }
          })
        }))} error={errors.automationTriggers[trigger.id]?.link?.join("")} />}</>;
    };
    $[3] = errors;
    $[4] = idx;
    $[5] = isStatic;
    $[6] = setRules;
    $[7] = t;
    $[8] = trigger.id;
    $[9] = trigger.link;
    $[10] = trigger.mailing.currentEmail?.subject;
    $[11] = trigger.mailing.id;
    $[12] = triggers;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== trigger) {
    t3 = <EditTriggerWrapper trigger={trigger} onDelete={t1}>{t2}</EditTriggerWrapper>;
    $[14] = t1;
    $[15] = t2;
    $[16] = trigger;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};
export default TriggerEmailLinkItem;